<template>
  <div>
    <Loader
      :loader="loading.activities"
    />
    <section
      v-if="!loading.activities"
      class="flex flex-col-reverse md:flex-row flex-wrap gap-2 justify-between py-8 px-2"
    >
      <div class="flex flex-wrap gap-2 md:gap-4">
        <span class="flex items-center justify-center gap-1">
          <v-icon name="bi-filter" scale="1.2" />
          <h6 class="px-1 py-3">{{ "Filtrar: " }}</h6>
        </span>

        <Dropdown
          :options="listCourses"
          placeholder="Selecione Curso"
          v-model="selectedCourse"
          optionLabel="name"
          optionValue="id"
          :loading="loading.courses"
          :emptyMessage="
            $t('labels.generic', {
              en: 'No course associated',
              pt: 'Nenhum curso associado',
            })
          "
          :emptyFilterMessage="
            $t('labels.generic', {
              en: 'No course found',
              pt: 'Nenhum curso encontrado',
            })
          "
          filter
          :showClear="selectedCourse!&&true"
          class="w-full md:w-auto"
          @filter="onFilterCourse"
          :disabled="loading.courses"
        />
        <Dropdown
          :options="listClasses"
          placeholder="Selecionar Turma"
          v-model="selectedClass"
          optionLabel="name"
          optionValue="id"
          :loading="loading.classes"
          :emptyMessage="
            $t('labels.generic', {
              en: 'No class associated',
              pt: 'Nenhuma turma associada',
            })
          "
          :emptyFilterMessage="
            $t('labels.generic', {
              en: 'No class found',
              pt: 'Nenhuma turma encontrada',
            })
          "
          filter
          :showClear="selectedClass!&&true"
          class="w-full md:w-auto"
          @filter="onFilterClass"
          :disabled="!selectedCourse"
        />
      </div>

      <Button
        label="Nova Atividade"
        class="btn-primary w-full md:w-auto"
        icon="pi pi-plus"
        @click.prevent="addActivity()"
      />
    </section>
    <Loader :loader="loading.activities" />
    <section v-if="studentActivities?.length > 0">
      <div v-for="(activity, index) in studentActivities" :key="index">
        <CardActivity
          :activityId="activity?.activityId"
          :students="activity?.students"
          :completed="activity?.completed"
          :feedback="activity?.feedback"
          :title="activity?.title"
          @onGoTo="(e) => goToCorrection(e)"
        />
      </div>
      <Paginator
        :rows="activityParams.size"
        :totalRecords="activityParams.total"
        v-if="activityParams?.total!>activityParams.size"
        @page="paginateActivities"
      />
    </section>

    <EmptyData
      :data="studentActivities?.length === 0"
      :label="emptyStateActivities.description"
      :image="emptyStateActivities.image"
      imgSize="h-40 md:h-64 mt-20"
      msgSize="md:w-3/12"
    />
  </div>
</template>
<script lang="ts">
const CardActivity = defineAsyncComponent(() => import("./activity-card.vue"));
import Loader from "@/components/Loader/loader.vue";
import { QueryParams } from "@/models/query-params.model";
import { ActivityRest } from "@/services/rest/activity.rest";
import { ClassesRest } from "@/services/rest/classes.rest";
import { CoursesRest } from "@/services/rest/courses.rest";
import { PageState } from "primevue/paginator";
import { defineAsyncComponent, defineComponent, ref } from "vue";

export default defineComponent({
  data() {
    return {
      studentActivities: [] as any,
      courseParams: { page: 0, size: 10, status: "PUBLISHED", name: "" },
      classParams: { page: 0, size: 10, courseId: "", name: "" },
      activityParams: new QueryParams(0, 5),
      loading: { classes: false, courses: false, activities: false },
      emptyStateActivities: {
        description: "Nenhuma atividade encontrada para essa turma",
        image: "empty-activity.svg",
      },
    };
  },
  components: { CardActivity },
  computed: {
    activityRest(): ActivityRest {
      return new ActivityRest();
    },
    courseRest(): CoursesRest {
      return new CoursesRest();
    },
    classRest(): ClassesRest {
      return new ClassesRest();
    },
  },
  setup() {
    const listCourses = ref([]);
    const listClasses = ref([]);
    const selectedClass = ref(null);
    const selectedCourse = ref(null);

    return {
      listCourses,
      listClasses,

      selectedClass,
      selectedCourse,
    };
  },
  methods: {
    getAllActivities() {
      this.goInitPage();
      this.loading.activities = true;
      this.activityRest.getAll(this.activityParams).subscribe({
        next: (res) => {
          this.studentActivities = res?.content;
          this.activityParams.size = res?.size;
          this.activityParams.page = res?.page;
          this.activityParams.total = res?.total;
          this.loading.activities = false;
        },
        error: () => {
          this.loading.activities = false;
        },
        complete: () => {
          this.loading.activities = false;
        },
      });
    },
    goInitPage() {
      window.scrollTo(0, 0);
    },
    addActivity() {
      this.$router.push({ name: "formActivity" });
    },
    goToCorrection(id: string) {
      this.$router.push({ name: "activityDetail", params: { id } });
    },
    getAllCourses() {
      this.loading.courses = true;
      this.courseRest.getCourses(this.courseParams).subscribe({
        next: (response) => {
          this.listCourses = response.content;
        },
        complete: () => {
          this.loading.courses = false;
        },
        error: () => {
          this.listCourses = [];
        },
      });
    },
    getAllClasses() {
      this.loading.classes = true;
      this.classRest.getAllClasses(this.classParams).subscribe({
        next: (response) => {
          this.listClasses = response.content;
        },
        complete: () => {
          this.loading.classes = false;
        },
        error: () => {
          this.listClasses = [];
        },
      });
    },
    onSelectCourse(event: any) {
      if (!event.value) delete this.activityParams.courseId;
      else this.activityParams.courseId = event.value;
      this.classParams.courseId = event.value;
      this.getAllClasses();
    },
    onSelectClass(event: any) {
      if (!event.value) delete this.activityParams.classroomId;
      else this.activityParams.classroomId = event.value;
      this.resetPaginate();
      this.getAllActivities();
    },
    onFilterCourse(event: any) {
      this.courseParams.name = event.value;
      this.getAllCourses();
    },
    onFilterClass(event: any) {
      this.classParams.name = event.value;
      this.resetPaginate();
      this.getAllClasses();
    },
    paginateActivities(event: PageState) {
      this.activityParams.page = event.page;
      this.activityParams.size = event.rows;
      this.getAllActivities();
    },
    resetPaginate() {
      this.activityParams.page = 0;
      this.activityParams.size = 5;
    },
  },
  watch: {
    selectedCourse(newValue) {
      this.onSelectCourse({ value: newValue });
    },
    selectedClass(newValue) {
      this.onSelectClass({ value: newValue });
    },
  },
  mounted() {
    this.getAllActivities();
    this.getAllCourses();
    this.getAllClasses();
  },
});
</script>
